import { configureStore } from "@reduxjs/toolkit";
import alertSlice from "./slices/alert";
import authSlice from "./slices/auth";
import categorySlice from "./slices/category";
import contentSlice from "./slices/content";
import advertisementSlice from "./slices/advertisement";
import directorySlice from "./slices/directory";
import logSlice from "./slices/log";
import reviewSlice from "./slices/review";

export const store = configureStore({
  reducer: {
    advertisement: advertisementSlice,
    auth: authSlice,
    alert: alertSlice,
    category: categorySlice,
    content: contentSlice,
    directory: directorySlice,
    log: logSlice,
    review: reviewSlice,
  },
});

// Infer the `RootState` and `AppDispatch` types from the store itself
export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
